module.exports = "/_next/static/images/ms-672d771e5fa890e48f4fe2e1ce0f6103.svg";